module.exports = __webpack_public_path__ + "media/images/country_flags/mx-2c1c8883b27005726e65c2c3463aab76.png";